var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-video-container"},[_c('video',{ref:"videoPlayer",staticStyle:{"object-fit":"contain"},attrs:{"preload":"metadata","controls":"","autoplay":"","muted":"","playsinline":"","data-plyr-config":"{\"fullscreen\": {\"enabled\": true, \"iosNative\": true}}"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }